// import React from 'react';
// import PropTypes from 'prop-types';
// import TextField from '@material-ui/core/TextField';
// import moment from 'moment';
// import _ from 'lodash';
//
// const getValue = (val) => {
//   if (!val) {
//     return '';
//   }
//
//   if (_.isDate(val)) {
//     return moment(val).format('ll');
//   }
//
//   return val.substr(0,10);
// }
//
// const DatePicker = ({ label, value, onChange, fullWidth }) => {
//   // console.log('DatePicker-value', value)
//   return (
//     <TextField
//       id="date"
//       label={label}
//       type="date"
//       fullWidth={fullWidth}
//       value={getValue(value)}
//       onChange={(evt) => onChange(evt.target.value) }
//       InputLabelProps={{
//         shrink: true,
//       }}
//     />
//   );
// }
//
// DatePicker.propTypes = {
//   label: PropTypes.string.isRequired,
//   // value: PropTypes.date,
// };
//
// export default DatePicker;


// WEBPACK FOOTER //
// ./src/components/Common/DatePicker/index.js